import APIUtils from '@spothero/utils/api';
import isNil from 'lodash/isNil';

const CityAPI = {
    get(slug) {
        return APIUtils.get(`cities/${slug}/`);
    },

    // NOTE!
    // This is a 'placeholder' API that uses /cities to get a particular city by ID.
    // There is currently no API to retrieve a city directly via ID.
    async getById(id) {
        const cities = await CityAPI.getAll().then(
            res => res.data.data.results
        );

        const city = cities.find(c => `${c.id}` === `${id}`);

        if (isNil(city)) {
            // eslint-disable-next-line no-throw-literal
            throw {status: 404, message: `Unable to find city by ID ${id}`};
        }

        return city;
    },

    getAll() {
        return APIUtils.get(`cities/`);
    },
};

export default CityAPI;
